module.exports = __webpack_public_path__ + "img/g0102.e66b9733.png";